//@ts-check

export class CheckoutPageState {
  /** @type {'me'|'client'} */
  licenseUsage;

  /** @type {string} */
  licenseUsageClientName;

  /** @type {boolean} */
  shouldIssuePartnerLicense;

  /** @type {boolean} */
  isBillingLicenseeMerged;

  /** @type {boolean} */
  isBillingShippingMerged;

  constructor(data) {
    this.licenseUsage = data.licenseUsage;
    this.licenseUsageClientName = data.licenseUsageClientName;
    this.shouldIssuePartnerLicense = data.shouldIssuePartnerLicense;
    this.isBillingLicenseeMerged = data.isBillingLicenseeMerged;
    this.isBillingShippingMerged = data.isBillingShippingMerged;
  }
}
